import { useState } from 'react';

import CircularLoading from '../../../Common/CircularLoading/CircularLoading';
import ConfirmationModal from './ConfirmationModal';
import SubmittedQuestionsItem from './SubmittedQuestionsItem';

function SubmittedQuestionsList({
  userSubmittedQuestions,
  isUserQuestionsLoading,
  deleteUserSubmittedQuestion,
  setDeleteStatusMessage,
  deleteStatusMessage,
  handleSetQuestionToEditValues,
  handleSetQuestionToEditInputs,
  handleResetQuestionToEdit,
  setSelectedQuestion: setSelectedQuestionReducer,
}) {
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleChangeSelectedQuestion = (questionId, timestamp) => {
    setSelectedQuestion({ questionId, timestamp });
  };

  const handleToggleModal = () => {
    setDeleteStatusMessage({ type: '', message: '' });
    setIsModalOpen((prev) => !prev);
  };

  const sortedSubmittedQuestions = userSubmittedQuestions.sort(
    (a, b) => Number(b.createdAt) - Number(a.createdAt),
  );

  return (
    <section className="list__container">
      {isUserQuestionsLoading && userSubmittedQuestions.length === 0 ? (
        <div className="loading-container">
          <CircularLoading className="loading-gif-waiting" />
        </div>
      ) : null}
      {userSubmittedQuestions.length > 0 ? (
        <>
          <h3>Submitted Questions List</h3>
          <div className="list__list">
            {sortedSubmittedQuestions.map((question) => (
              <SubmittedQuestionsItem
                setSelectedQuestion={setSelectedQuestionReducer}
                key={question.id}
                question={question}
                handleChangeSelectedQuestion={handleChangeSelectedQuestion}
                handleToggleModal={handleToggleModal}
                handleSetQuestionToEditValues={handleSetQuestionToEditValues}
                handleSetQuestionToEditInputs={handleSetQuestionToEditInputs}
              />
            ))}
          </div>
        </>
      ) : (
        !isUserQuestionsLoading && <p>No questions submitted yet.</p>
      )}
      {isModalOpen ? (
        <ConfirmationModal
          isOpen={isModalOpen}
          toggle={handleToggleModal}
          deleteUserSubmittedQuestion={deleteUserSubmittedQuestion}
          questionId={selectedQuestion.questionId}
          timestamp={selectedQuestion.timestamp}
          handleChangeSelectedQuestion={handleChangeSelectedQuestion}
          setDeleteStatusMessage={setDeleteStatusMessage}
          deleteStatusMessage={deleteStatusMessage}
          handleResetQuestionToEdit={handleResetQuestionToEdit}
          isUserQuestionsLoading={isUserQuestionsLoading}
        />
      ) : null}
    </section>
  );
}

export default SubmittedQuestionsList;
